export default "__VITE_ASSET__BJVmeCbG__"